"use client";

import { c as _c } from "react/compiler-runtime";
import { MantineProvider as BaseMantineProvider, createTheme, Loader } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import "@mantine/carousel/styles.css";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/tiptap/styles.css";
const theme = createTheme({
  fontFamily: 'var(--font-poppins), "Poppins", sans-serif',
  components: {
    // Single source of truth for every spinner in the app: always the brand
    // accent colour, so no usage needs to pass `color` and they stay identical.
    Loader: Loader.extend({
      defaultProps: {
        color: "var(--color-on-surface-accent)"
      }
    })
  }
});
export function MantineProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Notifications position="top-right" zIndex={10000} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <BaseMantineProvider theme={theme} defaultColorScheme="dark" forceColorScheme="dark">{t1}{children}</BaseMantineProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}